import React, { useEffect, useState } from 'react';
import { PageLoader } from 'components/common/Loader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ERoutes } from 'ts/enums';
import { useAuth } from 'context/AuthContext';
import { useAppDispatch } from 'redux/hooks';
import { setUserJustLoggedIn } from 'redux/auth/auth.slice';

function AuthCallbackPage() {
  const { isLogged } = useAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isExtension, setIsExtension] = useState(false);

  useEffect(() => {
    let callbackType = searchParams.get('type');

    if(callbackType && callbackType == 'extension' && isLogged) {
      dispatch(setUserJustLoggedIn(true));
      const accessToken = localStorage.getItem('ss.accessToken');

      axios.post(`http://127.0.0.1:${searchParams.get('localServerPort')}/auth/set-token`, { token: accessToken }).then(() => {
        setIsExtension(true);
      }).catch(() => {

      });
      
      return;
    }

    if (isLogged) {
      dispatch(setUserJustLoggedIn(true));
      navigate(ERoutes.MAIN, { replace: true });
    }
  }, [isLogged]);

  if(isExtension && isLogged) {
    return (
      <div className="pt-8">
        <p className='text-center'>Authentication success! You can now close this page and return to Adobe Premiere :)</p>
      </div>
    );
  }

  return (
    <div className="pt-8">
      <PageLoader />
    </div>
  );
}

export default AuthCallbackPage;
